import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Logo from '../assets/Logo.svg';
import './Navbar.css';

const Navbar = () => {
  const { t, i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const closeMenu = () => {
    setIsOpen(false);
  };


  return (
    <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
      <div className="navbar-container">
        <Link to="/" className="navbar-logo" onClick={closeMenu}>
          <img src={Logo} alt="Logo" className="logo-img" />
        </Link>
        
        <div className="menu-icon" onClick={toggleMenu}>
          <div className={isOpen ? 'hamburger active' : 'hamburger'}>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>

        <ul className={isOpen ? 'nav-menu active' : 'nav-menu'}>
          <li className="nav-item">
            <Link 
              to="/" 
              className={`nav-link ${location.pathname === '/' ? 'active' : ''}`} 
              onClick={closeMenu}
            >
              {t('navbar.home')}
            </Link>
          </li>
          <li className="nav-item">
            <Link 
              to="/diensten" 
              className={`nav-link ${location.pathname === '/diensten' ? 'active' : ''}`} 
              onClick={closeMenu}
            >
              {t('navbar.services')}
            </Link>
          </li>
          <li className="nav-item">
            <Link 
              to="/portfolio" 
              className={`nav-link ${location.pathname === '/portfolio' ? 'active' : ''}`} 
              onClick={closeMenu}
            >
              {t('navbar.portfolio')}
            </Link>
          </li>
          <li className="nav-item">
            <Link 
              to="/prijzen" 
              className={`nav-link ${location.pathname === '/prijzen' ? 'active' : ''}`} 
              onClick={closeMenu}
            >
              {t('navbar.prices')}
            </Link>
          </li>
          <li className="nav-item nav-item-cta">
            <Link to="/contact" className="nav-link nav-link-cta" onClick={closeMenu}>
              {t('navbar.contact')}
            </Link>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
